import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { class: "field mb-0" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  class: "label mt-4",
  for: "override"
}
const _hoisted_21 = {
  key: 0,
  class: "field"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  class: "label has-text-weight-normal",
  for: "overrideLarges"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 7,
  class: "mt-4"
}
const _hoisted_28 = { class: "subtitle" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = {
  key: 0,
  class: "progress is-large is-primary"
}
const _hoisted_31 = ["value"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "box mt-4 columns" }
const _hoisted_34 = { class: "column" }
const _hoisted_35 = { class: "has-text-weight-bold" }
const _hoisted_36 = { class: "has-text-weight-bold" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "has-text-weight-bold" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "has-text-weight-bold" }
const _hoisted_41 = { class: "column" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.error != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.warning(),
            class: "red"
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('setup.contactSupport')), 1)
      ]))
    : (_ctx.device != null && _ctx.deviceLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.hasRequestVersion())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h2", null, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.warning(),
                    class: "red"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.updateRequired', { name: _ctx.device.name })), 1)
                ]),
                (_ctx.configuration)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('setup.firmwareVersion', { version: _ctx.configuration.minVersionFirmware })), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('setup.updateFirmware', { name: _ctx.device.name })), 1)
              ]))
            : (!_ctx.deviceReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!_ctx.device.hasServerLicense)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "red"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.server.missing')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: _ctx.check(),
                            class: "green"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.server.found')), 1)
                        ]),
                        (!_ctx.device.hasDeviceLicense)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "red"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.missing')), 1)
                            ]))
                          : (_ctx.device.hasLicenseToUpdate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.check(),
                                  class: "orange"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.update')), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.check(),
                                  class: "green"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.found')), 1)
                              ]))
                      ])),
                  (_ctx.device.hasServerParameters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_ctx.device.hasParametersToUpdate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "orange"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.parameters.update')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "green"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.parameters.found')), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.configuration)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_font_awesome_icon, {
                          class: _normalizeClass({ orange: !_ctx.configApplied, green: _ctx.configApplied }),
                          icon: _ctx.check()
                        }, null, 8, ["class", "icon"]),
                        _createTextVNode(" Configuration : "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.configuration.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "red",
                          icon: _ctx.check()
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.configNotFound')), 1)
                      ])),
                  (!_ctx.device.hasTimeUpToDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "red"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.date.needUpdate')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "green"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.date.upToDate')), 1)
                      ])),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        id: "override",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.override) = $event)),
                        disabled: _ctx.status != '',
                        type: "checkbox",
                        class: "switch is-rounded is-warning"
                      }, null, 8, _hoisted_19), [
                        [_vModelCheckbox, _ctx.override]
                      ]),
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('setup.erase.base')), 1)
                    ]),
                    (_ctx.override)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            id: "overrideLarges",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.overrideLargesFiles) = $event)),
                            disabled: _ctx.status != '',
                            type: "checkbox",
                            class: "switch is-rounded is-danger"
                          }, null, 8, _hoisted_22), [
                            [_vModelCheckbox, _ctx.overrideLargesFiles]
                          ]),
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('setup.erase.all')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      disabled: _ctx.status != '',
                      class: "button is-primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setupDevice()))
                    }, _toDisplayString(_ctx.$t('setup.install')), 9, _hoisted_24),
                    _createElementVNode("button", {
                      disabled: _ctx.status != '',
                      class: "button is-warning",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rebootDevice()))
                    }, _toDisplayString(_ctx.$t('setup.reboot')), 9, _hoisted_25),
                    (_ctx.overrideLargesFiles && _ctx.status == '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "notification is-warning mt-4",
                          innerHTML: _ctx.$t('setup.warning')
                        }, null, 8, _hoisted_26))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.status), 1),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('setup.waiting')), 1),
                        (!_ctx.progress)
                          ? (_openBlock(), _createElementBlock("progress", _hoisted_30))
                          : (_openBlock(), _createElementBlock("progress", {
                              key: 1,
                              value: _ctx.progress,
                              class: "progress is-large is-primary",
                              max: "100"
                            }, null, 8, _hoisted_31))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('headset.ready')), 1),
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('headset.current', { version: _ctx.device?.currentConfig })), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('headset.thanks')), 1),
                  _createElementVNode("button", {
                    class: "button is-primary mt-4",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetDevice()))
                  }, _toDisplayString(_ctx.$t('headset.reset')), 1),
                  _createElementVNode("button", {
                    class: "button is-warning mt-4",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rebootDevice()))
                  }, _toDisplayString(_ctx.$t('headset.reboot')), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('headset.license.title')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('headset.license.owner')) + ":", 1),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.device.license.owner), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('headset.license.usage')) + ": ", 1),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.device.license.usage), 1)
                        ]),
                        (_ctx.device.license.issued)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                              _createTextVNode(_toDisplayString(_ctx.$t('headset.license.issued')) + ": ", 1),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.device.license.issued.toLocaleDateString()), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.device.license.expires)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                              _createTextVNode(_toDisplayString(_ctx.$t('headset.license.expires')) + ": ", 1),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.device.license.expires.toLocaleDateString()), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('headset.battery.title')), 1),
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('headset.battery.charge', {
                            technology: _ctx.device.battery.technology,
                            charged: _ctx.device.battery.percent
                        })), 1),
                      (_ctx.device.battery.percent)
                        ? (_openBlock(), _createElementBlock("progress", {
                            key: 0,
                            class: "mt-2 progress is-info is-large",
                            max: "100",
                            value: _ctx.device.battery.percent
                          }, null, 8, _hoisted_43))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('setup.loading')), 1)
        ]))
}